module.exports = __webpack_public_path__ + "img/badge_vod.365fe419.svg";